// src/utils/formUtils.js

// Generic helper to safely get nested error messages from react-hook-form errors object
export const getNestedError = (errors, path) => {
    if (!errors || !path) return undefined;
    const keys = path.split('.');
    return keys.reduce((obj, key) => (obj && obj[key] ? obj[key] : undefined), errors);
};